/* eslint-disable max-len */
import Vue from 'vue';
import Vuex from 'vuex';

import {
  GET_EXTERNAL_CC_INFO_GQL,
  GET_EXTERNAL_CC_DETAILS_GQL,
  MAP_USER_TO_EXTERNAL_CC,
  GET_ALL_TEAMS,
  GET_PLAID_CATEGORY,
  GET_PLAID_CATEGORY_ALL,
  GET_PLAID_MAPPED_CATEGORY,
  MAP_CATEGORY,
  REMOVED_PLAID_CARD_ID,
  CHANGE_ACC_NAME,
  SET_CARD_NAME,
} from '@/graphql/externalcc.gql';

import { defaultClient as apolloClient } from '@/plugins/vue-apollo';


Vue.use(Vuex);


export default {
  namespaced: true,

  state: {
    ccTransactions: [],
    setExtCardName: null,
    ccDetails: [],
    allPlaidCategory: [],
    PlaidCategory: [],
    allTeams: [],
    setMappedCategory: [],
    removeCardAccount: [],
    renameCardName: null,
    mapPlaidToSpendhub: null,
  },

  mutations: {
    SET_CARD_EXT_NAME(state, payload) {
      state.setExtCardName = payload;
    },
    SET_CC_TRANSACTIONS_PAYMENT(state, payload) {
      state.ccTransactions = payload;
    },
    SET_CC_DETAILS(state, payload) {
      state.ccDetails = payload;
    },
    SET_ALL_TEAM(state, payload) {
      state.allTeams = payload;
    },
    SET_PLAID_CATEGORY(state, payload) {
      state.PlaidCategory = payload;
    },
    SET_PLAID_CATEGORY_ALL(state, payload) {
      state.allPlaidCategory = payload;
    },
    SET_PLAID_MAPPED_CATEGORY(state, payload) {
      state.setMappedCategory = payload;
    },
    REMOVE_CARD_ACCOUNT(state, payload) {
      state.removeCardAccount = payload;
    },
    RENAME_CARD_ACCOUNT(state, payload) {
      state.renameCardName = payload;
    },
    MAP_CATEGORY_SPENDHUB(state, payload) {
      state.mapPlaidToSpendhub = payload;
    },
  },

  actions: {
    async getECCTransactions({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, { root: true });
      await apolloClient.query({
        query: GET_EXTERNAL_CC_INFO_GQL,
        variables: {
          ...payload,
        },
        fetchPolicy: 'network-only',
      })
        .then(({ data }) => {
          commit('SET_CC_TRANSACTIONS_PAYMENT', data.creditCardTransactionses);
          commit('shared/SET_LOADING_CHILD', false, { root: true });
        })
        .catch((err) => {
          commit('shared/SET_LOADING_CHILD', false, { root: true });
          console.log(err);
        });
    },

    async getCreditCards({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.query({
        query: GET_EXTERNAL_CC_DETAILS_GQL,
        variables: {
          ...payload,
        },
        fetchPolicy: 'network-only',
      })
        .then(({ data }) => {
          const array = [];
          data.cardAccountsCC.forEach((item) => {
            array.push({ ...item, editCardAccountName: false });
          });
          commit('SET_CC_DETAILS', array);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(err);
        });
    },

    async mapExternalCCToUser({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: MAP_USER_TO_EXTERNAL_CC,
          variables: {
            ...payload,
            user: payload.user.id,
            companyId: payload.Company.id,
          },
        })
        .then(() => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    async getAllTeams({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });

      const mappedData = [];
      await apolloClient
        .query({
          query: GET_ALL_TEAMS,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then(async ({ data }) => {
          const cats = [];
          await apolloClient
            .query({
              query: GET_PLAID_MAPPED_CATEGORY,
              variables: {
                ...payload,
              },
              fetchPolicy: 'network-only',
            })
            .then((MyData) => {
              MyData.data.plaidToSpendHubCategories.forEach((item) => {
                console.log(item);
                const d = item;
                // eslint-disable-next-line prefer-destructuring
                d.plaidCategory = item.plaidCategory;
                mappedData.push(item);
              });
            })
            .catch((err) => {
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              console.log(err);
            });

          data.groups.forEach(async (element) => {
            element.categories.forEach((item) => {
              const json = {
                id: '',
                plaidCategory: [],
                spendhubCategory: {
                  id: '',
                  categoryName: '',
                  group: {
                    id: '',
                    groupName: '',
                  },
                },
                recordStatus: 1,
              };
              json.spendhubCategory = item;
              cats.push(json);
            });
          });

          const mergedSubjects = cats.map((subject) => {
            const mappedData1 = mappedData.find((element) => {
              if (element.spendhubCategory) {
                return element.spendhubCategory.id === subject.spendhubCategory.id;
              }
            });
            return { ...subject, ...mappedData1 };
          });

          commit('SET_ALL_TEAM', mergedSubjects);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    async getPlaidCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_PLAID_CATEGORY,
          variables: {
            ...payload,
          },
        })
        .then(async ({ data }) => {
          await apolloClient
            .query({
              query: GET_PLAID_CATEGORY_ALL,
              variables: {
                ...payload,
              },
            }).then((data1) => {
              commit('SET_PLAID_CATEGORY_ALL', data1.data.plaidCategoryMasters);
            })
            .catch((err) => {
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              console.log(err);
            });

          commit('SET_PLAID_CATEGORY', data.plaidCategoryMasters);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    async changeAccountName({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: CHANGE_ACC_NAME,
          variables: {
            ...payload,
          },
        })
        .then(() => {
          commit('RENAME_CARD_ACCOUNT', new Date());
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    // // plaidToSpendHubCategories
    // async getPlaidMappedCategory({ commit }, payload) {
    //   commit('shared/SET_LOADING', true, { root: true });
    //   await apolloClient
    //     .query({
    //       query: GET_PLAID_MAPPED_CATEGORY,
    //       variables: {
    //         ...payload,
    //       },
    //     })
    //     .then(({ data }) => {
    //       console.log('GET_PLAID_MAPPED_CATEGORY', data);
    //       // commit('SET_PLAID_MAPPED_CATEGORY', data.plaidCategoryMasters);
    //       commit('shared/SET_LOADING', false, {
    //         root: true,
    //       });
    //     })
    //     .catch((err) => {
    //       commit('shared/SET_LOADING', false, {
    //         root: true,
    //       });
    //       console.log(err);
    //     });
    // },

    async mapCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      const dataToSend = [];
      payload.data.forEach((item) => {
        const arr = [];
        item.plaidCategory.forEach((item1) => {
          arr.push({ id: item1.id });
        });
        dataToSend.push({
          id: item.id ? item.id : '',
          plaidCategoryId: arr,
          categoryId: item.spendhubCategory.id,
          companyId: payload.CompanyId,
        });
        // }
      });
      await apolloClient
        .mutate({
          mutation: MAP_CATEGORY,
          variables: {
            mapData: dataToSend,
          },
        })
        .then(() => {
          commit('MAP_CATEGORY_SPENDHUB', new Date());
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    // plaidToSpendHubCategories
    async removeExtCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: REMOVED_PLAID_CARD_ID,
          variables: {
            ...payload,
          },
        })
        .then(({ data }) => {
          commit('REMOVE_CARD_ACCOUNT', data.removeItem);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    async setCardName({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: SET_CARD_NAME,
          variables: {
            ...payload,
          },
        })
        .then(({ data }) => {
          commit('SET_CARD_EXT_NAME', data.submitCardDetails);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },


  },

  getters: {
    setExtCardName: state => state.setExtCardName,
    ccTransactions: state => state.ccTransactions,
    ccDetails: state => state.ccDetails,
    allTeams: state => state.allTeams,
    allPlaidCategory: state => state.allPlaidCategory,
    PlaidCategory: state => state.PlaidCategory,
    setMappedCategory: state => state.setMappedCategory,
    removeCardAccount: state => state.removeCardAccount,
    mapPlaidToSpendhub: state => state.mapPlaidToSpendhub,
    renameCardName: state => state.renameCardName,
  },

};
